// extracted by mini-css-extract-plugin
export var textInput = "_kx-0";